import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  policeDepartmentValidatorRequired,
  radioValidator,
  statementCaseNumberValidatorRequired,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_STATEMENTS]: yup.object({
    [ComponentId.INCIDENT_STATEMENTS_TYPE]: radioValidator,
    [ComponentId.INCIDENT_STATEMENTS_POLICE_DEPARTMENT]:
      trimmedString.onlyIfFieldIsVisible(policeDepartmentValidatorRequired),
    [ComponentId.INCIDENT_STATEMENTS_CASE_NUMBER]:
      trimmedString.onlyIfFieldIsVisible(statementCaseNumberValidatorRequired),
  }),
};
